import React, {useCallback, useContext, useState} from "react"
import Breadcrumb, {BreadcrumbGroup} from "@amzn/meridian/breadcrumb";
import {FormattedMessage} from "react-intl";
import Row from "@amzn/meridian/row";
import {formatAlias, getFCLMLink, nullIfDefault, sortList} from "../util/Util";
import Text from "@amzn/meridian/text";
import Link from "@amzn/meridian/link";
import Heading from "@amzn/meridian/heading";
import {AssociatePerformanceContext} from "./context/AssociatePerformanceContext";
import Table, {TableCell, TableRow} from "@amzn/meridian/table";
import Tag from "@amzn/meridian/tag";
import {CapabilityContext} from "../global/context/CapabilityContext";
import {getStationCode} from "../network/NetworkUtil";


const AssociateDetailViewV2 = (props) => {

    const {viewModel} = useContext(AssociatePerformanceContext);
    const [sortColumn, setSortColumn] = useState("formattedStartTime")
    const [sortDirection, setSortDirection] = useState("ascending")
    const {configViewModel} = useContext(CapabilityContext)
    const onSort = useCallback(({sortColumn, sortDirection}) => {
        setSortDirection(sortDirection)
        setSortColumn(sortColumn)
    }, [])

    const stationCode = getStationCode();

    const associateInfo = viewModel.associatePerformance.find(associate => associate.alias === formatAlias(props.associate));

    const renderAssociateMetadata = () => {
        return <Row backgroundColor={"secondary"} spacingInset="medium" spacing={"xlarge"}>
            <Row>
                <Text type="h100">
                    <FormattedMessage id="associate.averagePickTime" defaultMessage="Average Pick Duration"/>
                </Text>
                <Text type="b200">{associateInfo.averageDuration}</Text>
            </Row>
            <Row>
                <Text type="h100">
                    <FormattedMessage id="routeInfo.associate" defaultMessage="Associate"/>
                </Text>
                <Link href={getFCLMLink(props.associate, configViewModel.stationConfig.fclmLinkEnabled, stationCode)} type="secondary" target="_blank" rel="noreferrer noopener">
                    {associateInfo.alias}
                </Link>
            </Row>
        </Row>
    }

    const renderAssociateTable = () => {
        return <Table headerRows={1}
                      showDividers={true}
                      showStripes={true}
                      spacing="medium"
                      sortColumn={sortColumn}
                      sortDirection={sortDirection}
                      onSort={onSort}>
            {renderAssociateTableHeader()}
            {renderAssociateRows()}
        </Table>
    }

    const renderAssociateTableHeader = () => {
        return <TableRow>
            <TableCell sortColumn="picklistCode">
                <FormattedMessage id="associate.picklist" defaultMessage="Picklist"/>
            </TableCell>
            <TableCell sortColumn="status">
                <FormattedMessage id="associate.status" defaultMessage="Status"/>
            </TableCell>
            <TableCell sortColumn="progress">
                <FormattedMessage id="associate.progress" defaultMessage="Progress"/>
            </TableCell>
            <TableCell sortColumn="formattedDuration">
                <FormattedMessage id="associate.duration" defaultMessage="Duration"/>
            </TableCell>
            <TableCell sortColumn="formattedStartTime">
                <FormattedMessage id="associate.start_time" defaultMessage="Start Time"/>
            </TableCell>
            <TableCell sortColumn="formattedEndTime">
                <FormattedMessage id="associate.end_time" defaultMessage="End Time"/>
            </TableCell>
        </TableRow>
    }

    const renderAssociateRows = () => {
        return sortList(associateInfo.picklists, sortColumn, sortDirection).map(row => {
            return <TableRow key={row.picklistCode}>
                <TableCell>
                    <Link onClick={() => onPicklistClicked(row)}>
                        {row.picklistCode}
                    </Link>
                </TableCell>
                <TableCell>
                    <Tag type={row.statusColor}>{row.status}</Tag>
                </TableCell>
                <TableCell>{row.progress}</TableCell>
                <TableCell>{row.formattedDuration}</TableCell>
                <TableCell>{row.formattedStartTime}</TableCell>
                <TableCell>{row.formattedEndTime}</TableCell>
            </TableRow>
        })
    }

    const onPicklistClicked = (row) => {
        const params = [
            "PickAssociates",
            nullIfDefault(row.routeId),
            nullIfDefault(null),                                      /* status */
            nullIfDefault(null),                                      /* stagingLocation */
            nullIfDefault(null),                                      /* hazmatWeight */
            nullIfDefault(associateInfo.alias),
            nullIfDefault(row.routeCode),
            nullIfDefault(row.stationCode),
            encodeURIComponent(nullIfDefault(row.picklistId))
        ]
        const url = "/routeDetail/" + params.join("/");
        props.history.push(url)
    }

    const onBackPress = () => {
        props.history.push("/pickassociates")
    }

    return (
        <div>
            <Row widths="100%" spacingInset="large large small">
                <BreadcrumbGroup>
                    <Breadcrumb onClick={onBackPress}>
                        <FormattedMessage id="routeInfo.pickAssociates" defaultMessage="Pick Associates"/>
                    </Breadcrumb>
                    <Breadcrumb>
                        <FormattedMessage id="associate.associate_detail" defaultMessage="Associate Detail"/>
                    </Breadcrumb>
                </BreadcrumbGroup>
            </Row>
            {associateInfo ?
                <div>
                    <Row widths="100%" spacingInset="small large small">
                        <Heading level={3} type="h600" alignment="left">{props.associate}</Heading>
                    </Row>
                    <Row widths="100%" spacingInset="small large small">
                        {renderAssociateMetadata()}
                    </Row>
                    <Row widths="100%" spacingInset="small large small">
                        {renderAssociateTable()}
                    </Row>
                </div>
                :
                <h1 style={{textAlign: "center"}}>
                    <FormattedMessage id="routeInfo.associateNotFound" defaultMessage="Associate not found!"/>
                </h1>
            }
        </div>
    )
}

export default AssociateDetailViewV2





// WEBPACK FOOTER //
// ./src/components/pickassociate/AssociateDetailViewV2.js